{
  "en": {
    "issue_category": {
      "labels": {
        "category_name": "Category name",
        "integration_warning": "An integration with the Aftercare module on your platform is active. If you want to create or edit categories, please ask us.",
        "new_category": "Category"
      }
    }
  }
}